import {SearchOutlined} from "@ant-design/icons";
import {Button, Modal, Space} from "antd";
import {useState} from "react";
import BrokerMultiSelect from "../../select/MultiSelect/BrokerMultiSelect";
import {useNavigate} from "react-router-dom";
import {LabelValue} from "../../../types/charts";

export default function SearchBroker() {

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedBroker, setSelectedBroker] = useState("")
    const navigate = useNavigate()

    return <>
        <Modal
            open={isModalOpen}
            title={'Ricerca broker'}
            okText={"Conferma"}
            onOk={() => {
                setIsModalOpen(false)
                navigate(`/brokers/${selectedBroker}`)
            }}
            okButtonProps={{
                disabled: !selectedBroker
            }}
            onCancel={() => setIsModalOpen(false)}
        >
            <Space
                direction={'vertical'}
            >
                Broker
                <BrokerMultiSelect
                    mode={undefined}
                    style={{width: '20rem'}}
                    onSelect={(v: LabelValue) => setSelectedBroker(v.value)}
                />
            </Space>
        </Modal>
        <Button
            icon={<SearchOutlined
                style={{
                    fontSize: '24px',
                    color: "#1890FF",
                }}
            />}
            type={'text'}
            onClick={() => setIsModalOpen(prevState => !prevState)}
        />
    </>
}